import { render, staticRenderFns } from "./Canvas.template.vue?vue&type=template&id=604b8eea&scoped=true&"
var script = {}
import style0 from "./Canvas.template.vue?vue&type=style&index=0&id=604b8eea&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604b8eea",
  null
  
)

export default component.exports